import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { Bundle } from "../models/bundle.model";

@Injectable({
    providedIn: 'root'
})
export class BundleService {
    private BUNDLE_API = 'bundle';
    constructor(private http: HttpClient) { }

    public getBundles(): Observable<Bundle[]> {
        return this.http.get<Bundle[]>(environment.dmePortalApi + this.BUNDLE_API + "/list");
    }

    public getBundle(bundleID: string): Observable<Bundle> {
        return this.http.get<Bundle>(environment.dmePortalApi + this.BUNDLE_API + "/get/" + bundleID);
    }
    
    public createBundle(bundle: Bundle): Observable<Bundle> {
        return this.http.post<Bundle>(environment.dmePortalApi + this.BUNDLE_API + "/create", bundle);
    }

    public deleteBundle(bundle: Bundle): Observable<any> {
        return this.http.delete<any>(environment.dmePortalApi + this.BUNDLE_API + "/delete/" + bundle.bundleID);
    }

}

